// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","CustomCursor":"CustomCursor_Uyaxr","IsHovering":"IsHovering_APo0L","NotHovering":"NotHovering_DUArx"};